import { render, staticRenderFns } from "./LaboratoryBindServiceRedirectPage.vue?vue&type=template&id=3dec65ef&scoped=true"
import script from "./LaboratoryBindServiceRedirectPage.vue?vue&type=script&lang=js"
export * from "./LaboratoryBindServiceRedirectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dec65ef",
  null
  
)

export default component.exports